import {setHash} from "@/utils/utils"

export default {

    setStartDate: (state, newDate) => {
        state.dates = {
            "BeginDate": newDate,
            "EndDate": state.dates["EndDate"],
        }
        setHash({"BeginDate": newDate})
    },

    setEndDate: (state, newDate) => {
        state.dates = {
            "BeginDate": state.dates["BeginDate"],
            "EndDate": newDate,
        }
        setHash({"EndDate": newDate})
    },

}
